import type { FC } from 'react';

import { Box, Button } from '@mantine/core';

import type { VoltageType } from 'models';

import cx from './VoltageTypeSwitch.module.scss';

const VoltageTypeSwitch: FC<{
    voltageType: VoltageType | null;
    voltageTypes: VoltageType[];
    onChange?: (voltageType: VoltageType) => void;
    theme?: 'light' | 'dark';
    variant?: 'outline' | 'filled';
    showAmpersand?: boolean;
    viewOnly?: boolean;
}> = ({ voltageTypes, voltageType, onChange, theme = 'light', variant = 'filled', showAmpersand, viewOnly }) => {
    const disabled = (!!voltageType && voltageTypes.length === 1) || viewOnly;

    const buttons = voltageTypes.map((voltageTypeOption) => (
        <Button
            className={cx.voltageTypeButton}
            style={{
                pointerEvents: disabled ? 'none' : 'all',
            }}
            radius="xs"
            component="button"
            onClick={() => {
                onChange?.(voltageTypeOption);
            }}
            data-voltage-type={voltageTypeOption}
            data-active={voltageType === voltageTypeOption}
            data-variant={variant}
            key={voltageTypeOption}
            disabled={disabled}
        >
            {voltageTypeOption}
        </Button>
    ));

    return (
        <Box className={cx.voltageTypeSwitch} data-theme={theme}>
            {buttons[0]}
            {showAmpersand && buttons.length > 1 && <span className={cx.ampersand}>&</span>}
            {buttons?.[1]}
        </Box>
    );
};

export { VoltageTypeSwitch };
